import type { ReportValueType } from '~/presentation/reports/common/type';

import { Text } from '@shopify/polaris';

interface PreviousCellProps {
  previousValue?: ReportValueType;
  isMergedWithPrev: boolean;
}
export const PreviousCell: React.FC<PreviousCellProps> = ({ previousValue, isMergedWithPrev }) => {
  if (isMergedWithPrev || typeof previousValue !== 'string') return null;

  return (
    <Text as="span" variant="bodySm" tone="subdued">
      {previousValue}
    </Text>
  );
};
